/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from 'utils/redux-utils';
import { NOTIFICATION_TYPES, Notification } from '../../../../utils/utils';
import { CashBoxDocumentsTabFilterParams, DocumentsListDto } from '../../..//api/documents/documentsClient.typings';
import { i18n } from '../../../translation/i18n';

export enum CashBoxDocumentsTabActionType {
    OPEN_CASHBOX_DOCUMENTS_TAB = 'CashBoxDocumentsTab/ open tab',
    EXIT_CASHBOX_DOCUMENTS_TAB = 'CashBoxDocumentsTab/ exit tab',
    FETCH_CASHBOX_DOCUMENTS_SUCCESS = 'CashBoxDocumentsTab/ fetch documents success',
    FETCH_CASHBOX_DOCUMENTS_ERROR = 'CashBoxDocumentsTab/ fetch documents error',
    APPLY_DOCUMENTS_FILTERING = 'CashBoxDocumentsTab/ apply documents filter',
    APPLY_DOCUMENTS_PAGING = 'CashBoxDocumentsTab/ apply documents paging',
    SHOW_NEW_DOCUMENTS = 'CashBoxDocumentsTab/ show new documents',
    SET_BASE_PARAMS_TO_POLL_NEW_DOCUMENTS = 'CashBoxDocumentsTab/ set base params to poll new documents',
    CHECK_NEW_DOCUMENTS_SUCCESS = 'CashBoxDocumentsTab/ check for new documents success',
    DOWNLOAD_DOCUMENTS = 'CashBoxDocumentsTab/ download documents as excel',
    DOWNLOAD_DOCUMENTS_SUCCESS = 'CashBoxDocumentsTab/ download documents as excel success',
    DOWNLOAD_DOCUMENTS_ERROR = 'CashBoxDocumentsTab/ download documents as excel error',
}

export const openCashBoxDocumentsTabAction = () =>
    createAction(CashBoxDocumentsTabActionType.OPEN_CASHBOX_DOCUMENTS_TAB);

export const exitCashBoxDocumentsTabAction = () =>
    createAction(CashBoxDocumentsTabActionType.EXIT_CASHBOX_DOCUMENTS_TAB);

export const applyDocumentsFilteringAction = (params: CashBoxDocumentsTabFilterParams) =>
    createAction(CashBoxDocumentsTabActionType.APPLY_DOCUMENTS_FILTERING, params);

export const applyDocumentsPagingAction = () => createAction(CashBoxDocumentsTabActionType.APPLY_DOCUMENTS_PAGING);

export const showNewDocumentsAction = () => createAction(CashBoxDocumentsTabActionType.SHOW_NEW_DOCUMENTS);

export const fetchCashBoxDocumentsSuccessAction = (documentsList: DocumentsListDto) =>
    createAction(CashBoxDocumentsTabActionType.FETCH_CASHBOX_DOCUMENTS_SUCCESS, documentsList);

export const fetchCashBoxDocumentsErrorAction = (notification: Notification) =>
    createAction(CashBoxDocumentsTabActionType.FETCH_CASHBOX_DOCUMENTS_ERROR, { notification });

export const setBaseParamsToPollNewDocumentsAction = (dateFrom: string) =>
    createAction(CashBoxDocumentsTabActionType.SET_BASE_PARAMS_TO_POLL_NEW_DOCUMENTS, dateFrom);

export const checkNewDocumentsSuccessAction = (documentsList: DocumentsListDto) =>
    createAction(CashBoxDocumentsTabActionType.CHECK_NEW_DOCUMENTS_SUCCESS, documentsList);

export const downloadDocumentsAction = () => createAction(CashBoxDocumentsTabActionType.DOWNLOAD_DOCUMENTS);

export const downloadDocumentsSuccessAction = () =>
    createAction(CashBoxDocumentsTabActionType.DOWNLOAD_DOCUMENTS_SUCCESS, {
        notification: {
            type: NOTIFICATION_TYPES[1],
            message: i18n.t('downloadings.fileCreationRequestAccepted'),
        },
    });

export const downloadDocumentsErrorAction = (notification: Notification) =>
    createAction(CashBoxDocumentsTabActionType.DOWNLOAD_DOCUMENTS_ERROR, { notification });

export type CashBoxDocumentsTabAction =
    | ReturnType<typeof openCashBoxDocumentsTabAction>
    | ReturnType<typeof exitCashBoxDocumentsTabAction>
    | ReturnType<typeof applyDocumentsFilteringAction>
    | ReturnType<typeof applyDocumentsPagingAction>
    | ReturnType<typeof showNewDocumentsAction>
    | ReturnType<typeof fetchCashBoxDocumentsSuccessAction>
    | ReturnType<typeof fetchCashBoxDocumentsErrorAction>
    | ReturnType<typeof setBaseParamsToPollNewDocumentsAction>
    | ReturnType<typeof checkNewDocumentsSuccessAction>
    | ReturnType<typeof downloadDocumentsAction>
    | ReturnType<typeof downloadDocumentsSuccessAction>
    | ReturnType<typeof downloadDocumentsErrorAction>;
